module.exports = __webpack_public_path__ + "assets/alert-danger-icon.6629b1b8.svg";